import { Popover as ArkPopover, PopoverRootProps } from "@ark-ui/react";
import { Children, CSSProperties, PropsWithChildren, ReactNode } from "react";
import Icon from "../Icon/Icon";
import Button from "../Button/Button";
import { Text } from "../typography/Text";
import { HStack, VStack } from "@zenchef/styled-system/jsx";
import { PopoverContent, PopoverPositioner, PopoverRoot } from "./popoverParts";
import { AromaPopoverVariantProps } from "@zenchef/styled-system/recipes";

export interface PopoverProps
  extends PropsWithChildren,
    PopoverRootProps,
    AromaPopoverVariantProps {
  trigger: ReactNode;
  title?: string;
  description?: string;
  positioning?: PopoverRootProps["positioning"];
  zIndex?: number;
  headerActionItems?: ReactNode;
  portalled?: boolean;
}

const Popover = ({
  trigger,
  title,
  description,
  positioning,
  headerActionItems,
  zIndex = 1,
  children,
  portalled,
  ...props
}: PopoverProps) => {
  const cssVars = {
    "--popover-z-index": zIndex,
    zIndex: zIndex,
  } as CSSProperties;

  return (
    <PopoverRoot positioning={positioning} portalled={portalled} {...props}>
      <ArkPopover.Trigger asChild>{trigger}</ArkPopover.Trigger>
      <PopoverPositioner style={cssVars}>
        <PopoverContent>
          <HStack
            justifyContent="flex-end"
            padding="padding.1"
            height="{sizes.2xl}"
            gap="gap.2"
          >
            {headerActionItems ? (
              <>
                {Children.map(headerActionItems, (item) => (
                  <ArkPopover.CloseTrigger asChild>
                    {item}
                  </ArkPopover.CloseTrigger>
                ))}
              </>
            ) : null}
            <ArkPopover.CloseTrigger asChild>
              <Button iconOnly hierarchy="secondary-subtler">
                <Icon name="x" />
              </Button>
            </ArkPopover.CloseTrigger>
          </HStack>
          {children ?? (
            <VStack
              alignItems="flex-start"
              gap="gap.1"
              padding="padding.4"
              paddingTop="padding.1"
            >
              {title && (
                <ArkPopover.Title>
                  <Text textStyle="title.m">{title}</Text>
                </ArkPopover.Title>
              )}
              {description && (
                <ArkPopover.Description>
                  <Text textStyle="paragraph.m.regular">{description}</Text>
                </ArkPopover.Description>
              )}
            </VStack>
          )}
        </PopoverContent>
      </PopoverPositioner>
    </PopoverRoot>
  );
};

export default Popover;
